/**
 * InfoPopover.jsx
 * Lichtgewicht ⓘ popover op basis van reactjs-popup.
 * Gebruik: <InfoPopover>Uitleg tekst hier</InfoPopover>
 */
import React from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

const triggerStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '1.2em',
  height: '1.2em',
  borderRadius: '50%',
  background: '#e8eeff',
  color: '#001a4d',
  fontSize: '0.8em',
  fontWeight: 'bold',
  cursor: 'help',
  userSelect: 'none',
  border: '1px solid #b4c002',
  lineHeight: 1,
  verticalAlign: 'middle',
  marginLeft: '0.3em',
};

const contentStyle = {
  background: '#fff',
  border: '1px solid #b4c002',
  borderRadius: 8,
  padding: '0.8em 1em',
  fontSize: '0.88em',
  color: '#222',
  maxWidth: 320,
  lineHeight: 1.6,
  boxShadow: '0 4px 16px rgba(0,26,77,0.12)',
  zIndex: 9999,
};

export default function InfoPopover({ children, label = 'ⓘ' }) {
  return (
    <Popup
      trigger={<span style={triggerStyle} role="button" tabIndex={0} aria-label="Meer informatie">{label}</span>}
      position={['top center', 'bottom center', 'right center']}
      on={['hover', 'focus']}
      closeOnDocumentClick
      mouseLeaveDelay={150}
      mouseEnterDelay={0}
      contentStyle={contentStyle}
      arrow
    >
      <div>{children}</div>
    </Popup>
  );
}
